export const AUTHENTICATION = 1;
export const GET_ACTIVATION_CODE = 10;
export const TYPE_LIST_STREAM = 31;
export const GET_SLAVE_SERVER = 100;

///////////////////////
export const LIST_DEVICE = 11;
export const LIST_DEVICE_AND_SHARE = 1333; //13
export const GATEWAY_UPDATE_INFO = 16;
export const LIST_STATE_DEVICES = 17;
export const SEARCH_DEVICE_BY_NAME = 18;
export const LIST_CAMERA_STORAGE_FILE = 212;
export const GENERATE_LINK_STORAGE_FILE = 213;
export const SEARCH_CONTACT = 302;
export const UN_SHARE_PERMISSION_USER = 303;
export const DEVICE_CHANGE_STATE = 8;
export const UPDATE_DEVICE = 29;
export const REMOVE_DEVICE = 39;
export const REQUIRE_ACTIVE_DEVICE = 30;
export const ADD_DEVICE = 22;
export const LIST_USER_SHARE_DEVICE = 14;
export const SHARE_PERMISSION_USER = 301;
export const SCAN_NEW_CAMERA = 12;
export const REQUEST_CHECK_STREAM = 211;
export const CHECK_RTSP_STREAM = 151;
export const UPDATE_CAMERA_INFO = 150;
export const CHECK_EXTERNAL_DEVICE = 57;
export const REQUEST_ADD_EXTERNAL_DEVICE = 36;
export const GET_DEVICE_INFO_EXTRA = 49;
export const LIST_ALL_DEVICE_BY_PAGE = 19;
export const LIST_DEVICE_BY_TAGS = 103;
export const STATISTIC_DEVICE = 102;
export const RESET_TOKEN = 311;
export const CHOOSE_NAMESPACE = 1000;
export const GENERATE_API_ACCESS_TOKEN = 900;
export const STATISTIC_DEVICE_STATUS = 107;

///////////////////////
export const CREATE_STREAM = 206;
export const START_STREAM_MONITOR = 250;
export const CREATE_RTSP_STREAM = 220;
export const WATCH_STREAM = 207;
export const START_STREAM = 208;
export const UPDATE_STREAM = 209;
export const STOP_STREAM = 210;
export const ROTATE_VIEW_CAMERA = 203;
export const ZOOM_VIEW_CAMERA = 204;
export const ZOOM_STATE_STREAM = 215;
export const UPDATE_STREAM_INFO = 216;
///////////////////////
export const GET_USER_INFO = 3;
export const UPDATE_USER_INFO = 4;
///////////////////////

export const LIST_NOTIFICATION = 60;
export const NEW_NOTIFICATION = 61;
export const UPDATE_NOTIFICATION = 62;
export const MARK_READ_NOTIFICATION = 72;
export const FILTER_NOTIFICATION = 74;

///////////////////////
export const REGISTER_NOTIFICATION = 70;
export const UNREGISTER_NOTIFICATION = 71;

////////////////////////

export const LIST_SERVICE = 40;
export const LIST_SERVICE_BY_DEVICE_SERIAL = 50;
export const CANCEL_SERVICE = 43;
export const LIST_DEVICE_BY_SERVICE_ID = 15;
export const LIST_TARGET_BY_SERVICE_ID = 58;
export const LIST_DEVICE_ACTIVE_SERVICE_ID = 13;
export const LIST_TARGET_ACTIVE_BY_SERVICE_ID = 59;
export const GET_LICENSE_INFO_SERVICE = 52;
export const ACTIVE_LICENSE_SERVICE = 51;
export const CONFIGURATION_SERVICE = 56;

///////////////////////
export const LIST_ACCOUNT_BY_NAMESPACE = 304;
export const LIST_ACCOUNT_BY_NAMESPACE_BY_PAGE = 317;
export const LIST_DETAIL_ROLE_OF_CUSTOMER = 270;
export const LIST_NAMESPACE_BY_ACCOUNT = 305;
export const LIST_ACTION_LOG_BY_NAMESPACE = 306;
export const LIST_ACTION_LOG_BY_PHONENUMBER = 316;

///////////////////////

export const ADD_WHITE_LIST_IP = 308;
export const LIST_WHITE_LIST_IP_BY_NAMESPACE = 310;
export const DELETE_WHITE_LIST_IP = 309;

///////////////////////

export const ADD_MEMBER = 470;
export const REMOVE_MEMBER = 471;
export const UPDATE_MEMBER = 472;
export const CONFIGURATION_USER = 85;

////////////////////////
export const SUMMARY_CAMERA = 700;
export const LIST_LICENSE_BY_NAMESPACE = 54;
export const LIST_DEVICE_GROUP = 320;
export const GET_DEVICE_GROUP_BY_ID = 325;
export const LIST_DEVICE_GROUP_BY_PAGE = 324;
export const LIST_DEVICE_GROUP_BY_PAGE_V2 = 327;
export const LIST_DEVICE_BY_DEVICE_GROUP_ID = 326;
export const ADD_DEVICE_GROUP = 321;
export const UPDATE_DEVICE_GROUP = 322;
export const DELETE_DEVICE_GROUP = 323;

export const LIST_CAMERA_STORAGE_FILE_DATE = 218;

///////////////////////

export const ADD_WHITE_LIST_DEVICE = 312;
export const LIST_WHITE_LIST_DEVICE_BY_NAMESPACE = 314;
export const DELETE_WHITE_LIST_DEVICE = 313;

///////////////////////

export const LIST_GROUP_MEMBER = 600;
export const ADD_GROUP_MEMBER = 601;
export const UPDATE_GROUP_MEMBER = 602;
export const DELETE_GROUP_MEMBER = 603;
export const SEARCH_GROUP_BY_NAME = 607;
export const LIST_DEVICE_BY_USER = 621;
export const LIST_GROUP_BY_PARENT_GROUP = 608;

///////////////////////

export const LIST_ACCOUNT_GROUP_MEMBER = 604;
export const ADD_ACCOUNT_GROUP_MEMBER = 606;
export const DELETE_ACCOUNT_GROUP_MEMBER = 605;

///////////////////////

export const SHARE_PERMISSION_GROUP = 299;
export const LIST_DEVICE_GROUP_BY_GROUP_ACCOUNT_BY_PAGE = 330;
export const LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE = 331;
export const DELETE_SHARE_PERMISSION_GROUP = 298;
export const UPDATE_SHARE_PERMISSION_USER = 315;

///////////////////////

export const GET_DEVICE_CONTACT_INFO = 55;

///////////////////////

export const LIST_ALERT = 406;
export const STATISTIC_ACTION_LOG_BY_NAMESPACE = 340;

///////////////////////

export const CHECK_LDAP_ACCOUNT = 950;
export const AUTHENTICATION_LDAP = 951;
export const AUTHENTICATION_PASSWORD = 955;

///////////////////////

export const ADD_SUB_STREAM_CAMERA = 219;

export const REPORT_ACTION_LOG = 341;

export const UPLOAD_STORAGE_FILE = 225;
export const REQUEST_UPLOAD_FILE = 226;
export const REMOVE_STORAGE_FILE = 227;
export const REQUEST_UPLOAD_S3_FILE = 230;
export const UPDATE_TAGS_STORAGE_FILE = 467;
export const LIST_STORAGE_FILE_BY_TAG = 465;
export const LIST_DEVICE_BY_STATE = 328;

export const AUTHENTICATION_AZURE = 954;
export const AUTHENTICATION_GOOGLE = 958;
export const LIST_NOTIFICATION_EVENT = 120;

export const SEND_EMAIL_NOTIFICATION = 76;
export const UPDATE_STATE_DEVICES = 77;

export const ADD_PLACE = 453;
export const UPDATE_PLACE = 451;
export const REMOVE_PLACE = 452;
export const REMOVE_DEVICE_GROUP = 323;
export const LIST_ALL_PLACE_BY_PAGE = 454;
export const LIST_ALL_PLACE = 455;
export const GET_PLACE_BY_ID = 456;

export const REQUEST_MAKE_CALL_OUT = 260;

export const GENERATE_LINK_STORAGE_FILE_BY_TIME = 229;
export const START_PLAYBACK_CAMERA = 285;
export const CHANGE_USER_PASSWORD = 80;
export const RESET_USER_PASSWORD = 81;
export const LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP = 332;

export const GENERATE_SHORT_TOKEN = 280;

/////////////////////// Alert detect
export const DETECT_OBJECT = 521;
export const DETECT_PERSON = 520;
export const DETECT_WEAPON = 526;
export const DETECT_FIRE = 531;
export const DETECT_VIRTUAL_WALL = 532;
export const RECOGNITION_FACE = 529;

////////////////////////////////////
export const LINK_DEVICE = 95;
export const UN_LINK_DEVICE = 96;

export const LIST_PLAYBACK_ON_CLOUD = 289;
export const SEARCH_ADVANCE = 345;
export const PING_PLAYBACK_CAMERA = 286;
